import { request } from '../utils/request';

export const triggerCaseReportCron = params =>
  request.post('/superadmin/engagement-case-report/trigger', params);

export const fetchCronStatus = () =>
  request.get('/superadmin/engagement-case-report/status');

export const fetchCronRuns = params =>
  request.get('/superadmin/engagement-case-report/cron-runs', { params });
export const resetCronState = () =>
  request.post('/superadmin/engagement-case-report/reset');

export const clearAggregationCache = params =>
  request.post(
    '/superadmin/engagement-case-report/clear-aggregation-cache',
    params
  );
